import styled from 'styled-components'

export const LockBackdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(18, 39, 54, 0.72);
  backdrop-filter: blur(8px);
`

export const LockCard = styled.div`
  width: min(100%, 560px);
  max-height: 100%;
  overflow: auto;
  padding: 34px;
  border-radius: 32px;
  border: 1px solid rgba(182, 194, 214, 0.72);
  background: #ffffff;
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.24);
`

export const LockEyebrow = styled.span`
  display: block;
  margin-top: 18px;
  color: #2d749c;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-align: center;
  text-transform: uppercase;
`

export const LockTitle = styled.h1`
  margin: 16px 0 10px;
  color: #183449;
  font-size: 2rem;
  text-align: center;
`

export const LockDescription = styled.p`
  margin: 0 0 24px;
  color: #587084;
  font-size: 1rem;
  line-height: 1.6;
  text-align: center;
`
